import "./OurStory.module.css";
import Header from "@/reusable_sections/Header";
import OurStoryHero from "./sections/OurStoryHero";
import TheMorganneLegacy from "./sections/TheMorganneLegacy";
import OurMissionValues from "./sections/OurMissionValues";
import BuiltForMo from "./sections/BuiltForMo";
import TheEvolution from "./sections/TheEvolution";
import Footer from "@/reusable_sections/Footer";
import { Suspense } from "react";
export default function OurStoryPage() {
  return <div>
      <Header />
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Loading...</div>}>
        <OurStoryHero />
      </Suspense>
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Loading...</div>}>
        <TheMorganneLegacy />
      </Suspense>
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Loading...</div>}>
        <BuiltForMo />
      </Suspense>
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Loading...</div>}>
        <TheEvolution />
      </Suspense>
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Loading...</div>}>
        <OurMissionValues />
      </Suspense>
      <Footer />
    </div>;
}